export const SET_RECEIPT_IS_LOADING = 'SET_RECEIPT_IS_LOADING'